import React, { useMemo, useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import { useNavigate } from "react-router";
import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const TopBottomProductsTable = ({ tabledata }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [flag, setflag] = useState(false);
  const is_lahloob = useSelector(
    (state) => state.login?.user?.result?.is_lahloob
  );

  const lang = i18n.language;

  // console.log("BOTTOM TABLE  DATA _------>", tabledata);

  const data = useMemo(() => {
    if (Array.isArray(tabledata)) {
      return tabledata;
    } else if (tabledata && typeof tabledata === "object") {
      return [];
    }
    return [];
  }, [tabledata]);

  useEffect(() => {
    if (data.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [data, flag]);

  const columns = useMemo(
    () => [
      {
        Header: t("Order Date"),
        accessor: "order_date",
        Cell: ({ value }) => value || "0",
      },
      {
        Header: t("Barcode"),
        accessor: "barcode",
      },
      {
        Header: t("Product Name"),
        accessor: "product_name",
      },
      {
        Header: (
          <div className="text-start" title={t("Product Groups")}>
            {t("Product Groups")}
          </div>
        ),
        width: "10%", // Add this line
        accessor: "product_group",
        Cell: ({ row }) => (
          <div className="text-start">{`${row.original.product_group}`}</div>
        ),
      },
      {
        Header: t("Purchase Price"),
        accessor: "purchase_price",
        Cell: ({ value }) => `EGP ${value?.toFixed(2)} `,
      },
      {
        Header: t("Sale Price"),
        accessor: "sale_price",
        Cell: ({ value }) => `EGP ${value?.toFixed(2)} `,
      },
      // {
      //   Header: t("Profit %"),
      //   accessor: "profit",
      //   Cell: ({ value }) => `${value?.toFixed(2)} %`,
      //   width: 150,
      // },
      {
        Header: t("Profit %"),
        accessor: "profit",
        width: 150,
        Cell: ({ value }) => {
          const lang = i18n.language; // or use document.dir
          const formattedValue = value?.toFixed(2) || "0.00";

          // RTL languages like Arabic
          if (lang === "ar") {
            return `% ${formattedValue}`;
          }

          // LTR (default)
          return `${formattedValue} %`;
        },
      },
      {
        Header: t("Quantity Purchased"),
        accessor: "quantity",
        Cell: ({ value }) => `${value}`,
      },
      {
        Header: t("Daily Avg. Sale"),
        accessor: "daily_avg_sale",
        Cell: ({ value }) => `${value?.toFixed(2)}`,
      },
      {
        Header: t("Inventory in Days"),
        accessor: "inv_in_days",
      },
    ],
    [t]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 5 },
    },
    useSortBy,
    usePagination
  );

  return (
    <div
      className="container mx-auto float-left h-[100%]"
      style={{ maxWidth: "100%" }}
    >
      <div className="flex flex-col h-full items-center">
        {tabledata?.length === 0 && flag === false ? (
          <div className="h-screen w-[90%] mt-2 ms-4">
            <ShimmerLoader />
          </div>
        ) : (
          <div className="overflow-x-auto scrollbar-thin w-full">
            {" "}
            {/* Add this wrapper for horizontal scrolling */}
            {page.length === 0 ? (
              <Empty className="mt-16" description={t("No product found")} />
            ) : (
              <table
                {...getTableProps()}
                className=" my-4 font-normal ms-3 me-3 min-w-[800px] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] min-h-auto h-[100%] shadow-xl overflow-hidden  rounded-lg"
                // className="mt-7 font-normal max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] min-h-auto h-[100%] shadow-xl rounded-lg overflow-hidden"
                style={{
                  direction: i18n.language === "ar" ? "rtl" : "ltr",
                }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className={`py-3 px-4 whitespace-nowrap ${i18n.language === "ar"
                                ? "text-right"
                                : "text-left"
                                }`}
                            >
                               <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                                                                              {column.render("Header")}
                                                                                              {column.canSort && (
                                                                                                <span className="ms-1">
                                                                                                  {column.isSorted ? (
                                                                                                    column.isSortedDesc ? (
                                                                                                      <img
                                                                                                        src={Vectorsorting}
                                                                                                        style={{
                                                                                                          minHeight: 10,
                                                                                                          minWidth: 10,
                                                                                                        }}
                                                                                                        alt="vector"
                                                                                                      />
                                                                                                    ) : (
                                                                                                      <img
                                                                                                        className="rotate-180"
                                                                                                        src={Vectorsorting}
                                                                                                        alt="vector"
                                                                                                      />
                                                                                                    )
                                                                                                  ) : (
                                                                                                    // 👇 Show a neutral icon when column is not sorted
                                                                                                    <img
                                                                                                      src={Vectorsorting}
                                                                                                      alt="sortable"
                                                                                                      style={{
                                                                                                        minHeight: 10,
                                                                                                        minWidth: 10,
                                                                                                        opacity: 0.3,
                                                                                                      }}
                                                                                                    />
                                                                                                  )}
                                                                                                </span>
                                                                                              )}
                                                                                            </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
                <tbody
                  {...getTableBodyProps()}
                  className="bg-[#F7F9FD] text-left"
                >
                  {page.map((row, rowIndex) => {
                    prepareRow(row);
                    const { key: rowKey, ...rowProps } = row.getRowProps();
                    return (
                      <React.Fragment key={rowKey}>
                        <tr
                          {...rowProps}
                          className="relative hover:bg-white transition duration-300 border-b border-gray-300 cursor-pointer"
                        //   onClick={() =>
                        //     openOrderList(row.original.order_details.order_no)
                        //   }
                        >
                          {row.cells.map((cell, cellIndex) => {
                            const { key: cellKey, ...cellProps } =
                              cell.getCellProps();
                            return (
                              <td
                                key={cellKey}
                                {...cellProps}
                                className={`p-2 px-4 text-[#272728] text-sm font-normal ${i18n.language === "ar"
                                  ? "text-right"
                                  : "text-left"
                                  } ${cell.column.id === "profit" ? "min-w-[100px]" : ""}`}
                              >
                                {cell.render("Cell")}
                              </td>
                            );
                          })}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page?.length === 0 && (
                    <tr>
                      <td colSpan={columns.length}>
                        <Empty description={t("No data available")} />
                      </td>
                    </tr>
                  )}
                  {/* <tr>
                <td colSpan={columns.length}>
                  <CustomPagination
                    data={tabledata?.length}
                    pageIndex={pageIndex}
                    pageCount={page?.length}
                    canPreviousPage={pageIndex !== 1}
                    canNextPage={tabledata?.length >= 10}
                    gotoPage={(page) => nextPage(page)}
                    previousPage={() => setpageIndex(pageIndex - 1)}
                    nextPage={() => setpageIndex(pageIndex + 1)}
                    pageSize={pageSize}
                    setPageSize={(pageSize) => setPageSize(pageSize)}
                  />
                </td>
              </tr> */}
                </tbody>
              </table>
            )}
          </div>
        )}
        {/* {page.length != 0 && (
        <div className="w-full">
          <CustomPagination
            data={tabledata?.length}
            pageIndex={pageIndex}
            pageCount={page?.length}
            canPreviousPage={pageIndex !== 1}
            canNextPage={tabledata?.length >= 10}
            gotoPage={(page) => nextPage(page)}
            previousPage={() => setpageIndex(pageIndex - 1)}
            nextPage={() => setpageIndex(pageIndex + 1)}
            pageSize={pageSize}
            setPageSize={(pageSize) => setPageSize(pageSize)}
          />
        </div>
         )} */}
      </div>
    </div>
  );
};

export default TopBottomProductsTable;
